module.exports = __webpack_public_path__ + "files/51f205b6e699e4265d359bc731aa9a98.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/nature-1.png
// module id = 1605
// module chunks = 60